/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unicorn/switch-case-braces */
/* eslint-disable unicorn/prefer-export-from */
import { Result } from '../Result/index.js';
import { dual } from '../function/dual.js';
import {} from 'effect/Result';
import { error as _error, loading as _loading, notInitiated as _notInitiated, success as _success, } from './base.js';
import { LOADING_TAG, SUCCESS_TAG, ERROR_TAG, NOT_INITIATED_TAG, } from './constants.js';
//#endregion
//#endregion
//#region constructors
export const loading = _loading;
export const notInitiated = _notInitiated;
export const success = _success;
export const error = _error;
//#endregion
//#region refinements
export const isSuccess = (as) => as.type === 'Success';
export const isError = (as) => as.type === 'Error';
export const isLoading = (as) => as.type === 'Loading';
export const isNotInitiated = (as) => as.type === 'NotInitiated';
export const isReady = (as) => isSuccess(as) || isError(as);
//#endregion
export const map = dual(2, (fa, f) => isSuccess(fa) ? success(f(fa.value)) : fa);
/**
 * Folding AsyncState using functions for each state type.
 * @param state AsyncState
 * @param matcher Matchers
 * @returns Union of values returned by mathcer functions
 */
export const match = dual(2, (state, matcher) => {
    switch (state.type) {
        case ERROR_TAG:
            return matcher[ERROR_TAG](state.error);
        case LOADING_TAG:
            return matcher[LOADING_TAG]();
        case SUCCESS_TAG:
            return matcher[SUCCESS_TAG](state.value);
        case NOT_INITIATED_TAG:
            return matcher[NOT_INITIATED_TAG]();
    }
});
/**
 * Folding AsyncState using functions for "Error", "Success" and "Waiting"(merges "NotInitiated" and "Loading" states).
 * @param state AsyncState
 * @param matcher WaitingMatchers
 * @returns Union of values returned by mathcer functions
 */
export const matchWaiting = dual(2, (state, matcher) => {
    switch (state.type) {
        case ERROR_TAG:
            return matcher[ERROR_TAG](state.error);
        case LOADING_TAG:
            return matcher.Waiting(LOADING_TAG);
        case SUCCESS_TAG:
            return matcher[SUCCESS_TAG](state.value);
        case NOT_INITIATED_TAG:
            return matcher.Waiting(NOT_INITIATED_TAG);
    }
});
/**
 * Composes computations in sequence, using the return value of one computation to determine the next computation.
 *
 * @category instance operations
 * @since 2.6.0
 */
export const chain = dual(2, (ma, f) => (isSuccess(ma) ? f(ma.value) : ma));
/**
 * Map a function over the first type argument of a bifunctor.
 *
 * @category instance operations
 */
export const mapLeft = (f) => (fa) => isError(fa) ? error(f(fa.error)) : fa;
//#region fp-ts interop
export const fromResult = (result) => {
    if (Result.isSuccess(result)) {
        return success(result.success);
    }
    return error(result.failure);
};
export const toResult = (as) => as.type === 'Success' ? Result.succeed(as.value) : Result.fail(as.error);
//#endregion
//#region js interop
/**
 * Takes a default and a nullable value, if the value is not nully, turn it into a `Success`, if the value is nully use
 * the provided default as a `Error`.
 */
export const fromNullable = (e) => (a) => a === null || a === undefined ? error(e) : success(a);
/**
 * Version of `fromNullable` with `NonInitialized` state.
 */
export const fromNullableN = fromNullable;
export const getOrElse = (onOther) => (as) => isSuccess(as) ? as.value : onOther();
export const getOrElseW = (onOther) => (as) => isSuccess(as) ? as.value : onOther();
//#endregion
export const getTag = (state) => state.type;
export function combineI(states, fn) {
    const someError = states.find(isError);
    if (someError !== undefined) {
        return error(someError.value);
    }
    const someLoading = states.find(isLoading);
    if (someLoading !== undefined) {
        return loading();
    }
    const someNotInitiated = states.find(isNotInitiated);
    if (someNotInitiated !== undefined) {
        return notInitiated();
    }
    const values = states.map((t) => t.value);
    return success(fn.apply(undefined, values));
}
export const tap = dual(2, (self, f) => {
    if (isSuccess(self)) {
        f(self.value);
    }
    return self;
});
//# sourceMappingURL=AsyncStateN.js.map